<template>
  <div class="collectBillManage">
    <!-- “collectBill”限制css于本页面 -->
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @companyChange="companyChange"
      @arrivalChange="arrivalChange"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        :rowStyle="rowStyle"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field.indexOf('[0].') != -1">
              {{
                scope.row[item.field.split('[0].')[0]]
                  ? scope.row[item.field.split('[0].')[0]][0][item.field.split('[0].')[1]]
                  : ''
              }}
            </span>
            <span v-else-if="item.field.indexOf('.') != -1">
              {{
                scope.row[item.field.split('.')[0]]
                  ? scope.row[item.field.split('.')[0]][item.field.split('.')[1]]
                  : ''
              }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      :isShowDownTemplateBtn="true"
      ref="SiruiUpload"
      :data="{ ...token, billType: '1' }"
    ></sirui-upload>
  </div>
</template>
<script>
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/capitalCenter/bill';
  import siruiUpload from '@/components/SiruiUpload';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'collectBillManage',
    mixins: [tableMixins],
    components: {
      siruiUpload,
    },
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 公司
            name: this.$t('billList.column.billCompanyCode'),
            prop: 'billCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            // 票据性质
            name: this.$t('billList.column.billProperty'),
            prop: 'billProperty',
            type: 'dict',
            dictType: 'bill_property',
          },
          {
            // 票据类型
            name: this.$t('billList.column.billCategory'),
            prop: 'billCategory',
            type: 'dict',
            dictType: 'bill_category',
          },
          {
            // 开票日期从
            name: '开票日期从',
            prop: 'billMakeDateBegin',
            type: 'startDaterangePicker',
          },
          {
            // 开票日期到
            name: '开票日期到',
            prop: 'billMakeDateEnd',
            type: 'endDaterangePicker',
          },
          {
            // 收票部门
            name: this.$t('billList.column.billTakeDepartmentName'),
            prop: 'billTakeDepartmentNo',
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 票据状态
            name: this.$t('billList.column.billStatus'),
            prop: 'billStatus',
            type: 'dict',
            dictType: 'collect_bill_status',
          },
          {
            // 认领状态
            name: '认领状态',
            prop: 'claimStatus',
            type: 'dict',
            dictType: 'bill_claim_status',
          },
          {
            // 是否质押
            name: this.$t('billList.column.isPledge'),
            prop: 'isPledge',
            type: 'select',
            options: this.pledgeList,
            filterable: true,
          },
          {
            // 入账银行名称
            name: '入账银行名称',
            prop: 'arrivalBranchName',
            type: 'searchTableSpec',
            searchType: 'bankAccountBranchName',
            currentValue: this.query.arrivalBranchName,
            isMultiple: true,
            isNeedMultipleValue: false,
            changeMethod: 'arrivalChange',
          },
          {
            // 入账银行账号
            name: '入账银行账号',
            prop: 'arrivalBankAccount',
            type: 'searchTableSpec',
            searchType: 'bankAccountBranchName',
            currentValue: this.query.arrivalBankAccount,
            filterable: true,
            isMultiple: true,
            isNeedMultipleValue: false,
            changeMethod: 'arrivalChange',
          },
          {
            // 应收票据号
            name: this.$t('billList.column.collectBillCode'),
            prop: 'billCode',
            type: 'input',
          },

          /* {
          // 应收票据流水号
          name: this.$t('billList.column.collectBillSerialNumber'),
          prop: "billSerialNumber",
          type: "input"
        },
        { // 付款单位
          type: "searchTableSpec",
          prop: "customerNoList",
          name: '客户',
          searchType: "customer",
          isMultiple: false
        },
        {
          type: 'dict',
          prop: 'accountingStatus',
          name: this.$t('saleInvoice.accountingStatus'),
          dictType: "post_status" ,
        },
        {
          // 到期日从
          name: '到期日从',
          prop: "expiringDateBegin",
          type: "startDaterangePicker"
        },
        {
          // 到期日到
          name: '到期日到',
          prop: "expiringDateEnd",
          type: "endDaterangePicker"
        },
        {
          // 收票日期从
          name: '收票日期从',
          prop: "billTakeDateBegin",
          type: "startDaterangePicker
        },
        {
          // 收票日期到
          name: '收票日期到',
          prop: "billTakeDateEnd",
          type: "endDaterangePicker"
        },
        {
          // 背书日期从
          name: '背书日期从',
          prop: "endorseDateBegin",
          type: "startDaterangePicker"
        },
        {
          // 背书日期到
          name: '背书日期到',
          prop: "endorseDateEnd",
          type: "endDaterangePicker"
        },
        {
          // 录入日期从
          name: '录入日期从',
          prop: "billRecordDateBegin",
          type: "startDaterangePicker"
        },
        {
          // 录入日期到
          name: '录入日期到',
          prop: "billRecordDateEnd",
          type: "endDaterangePicker"
        },
        {
          // 背书部门
          name: this.$t('billList.column.endorseDepartmentNo'),
          prop: "endorseDepartmentNo",
          type: "select",
          options: this.departmentList,
          filterable: true
        },
        {
          // 录入人
          name: "录入人",
          prop: "billRecorderNo",
          type: "searchTableSpec",
          searchType: "personnel",
          isMultiple: true,
        },
        {
          prop: "voucherNo",
          name: "凭证号",
          type: "input",
          placeholder: this.$t(
            "请输入凭证号"
          )
        },
        {//收票金额开始结束
          type: "inputRange",
          prop: ["billAmountMin", "billAmountMax"],
          precision: 2, //精度，就是保留几位小数,默认两位
          max: 99999999999999.99,
          name: "收票金额"
        },
        {
          // 收票人
          name: "收票人",
          prop: "billTakerName",
          type: "input",
        }, */
        ];
      },
    },
    data() {
      return {
        footerTotalCols: { amount: ['billAmount'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        action: API.IMPORT_FUNDBILL,
        query: {
          billSerialNumber: null, // 应收票据流水号
          billCompanyCode: null, // 公司
          billCode: null, // 应收票据号
          billProperty: null, // 票据性质
          billCategory: null, // 票据类型
          billMakeDateBegin: null, // 开票日期从
          billMakeDateEnd: null, // 开票日期到
          billTakeDepartmentNo: null, // 收票部门
          customerNoList: [], // 客户
          billStatus: null, // 票据状态
          accountingStatus: null,
          isPledge: null, // 是否质押
          expiringDateBegin: null, // 到期日从
          expiringDateEnd: null, // 到期日到
          billTakeDateBegin: null, // 收票日期从
          billTakeDateEnd: null, // 收票日期到
          endorseDateBegin: null, // 背书日期从
          endorseDateEnd: null, // 背书日期到
          endorseDepartmentNo: null, // 背书部门
          billType: '1', // 票据分类
          searchOrderItems: [],
          billRecorderNo: null, //录入日期
          billRecordDateBegin: null, //录入日期
          billRecordDateEnd: null, //录入人
          isClaim: null, //是否已认领,1-是,0-否'
          voucherNo: null,
          billAmountMin: null, //收票金额开始
          billAmountMax: null, //收票金额结束
          billTakerName: null, //收票人
          arrivalBranchName: null, //入账银行分行名称
          arrivalBranchCode: null, //入账银行代码
          arrivalBankAccount: null, //入账银行账号
        },
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          // 应收票据流水号
          {
            field: 'billSerialNumber',
            title: 'billList.column.collectBillSerialNumber',
            visible: true,
            width: 120,
          },
          // 公司
          {
            field: 'billCompanyName',
            title: 'billList.column.billCompanyCode',
            visible: true,
            width: 180,
          },
          // 应收票据号
          {
            field: 'billCode',
            title: 'billList.column.collectBillCode',
            visible: true,
            width: 120,
          },
          // 票据性质
          {
            field: 'billProperty',
            title: 'billList.column.billProperty',
            visible: true,
            width: 120,
            dictType: 'bill_property',
          },
          // 票据类型
          {
            field: 'billCategory',
            title: 'billList.column.billCategory',
            visible: true,
            width: 120,
            dictType: 'bill_category',
          },
          // 票据金额
          {
            field: 'billAmount',
            title: 'billList.column.billAmount',
            visible: true,
            width: 120,
            format: 'formatAmount',
          },
          // 票据状态
          {
            field: 'billStatus',
            title: 'billList.column.billStatus',
            visible: true,
            width: 120,
            dictType: 'collect_bill_status',
          },
          // 收票部门
          {
            field: 'billTakeDepartmentName',
            title: 'billList.column.billTakeDepartmentName',
            visible: true,
            width: 120,
          },
          // 到期日
          {
            field: 'expiringDate',
            title: 'billList.column.expiringDate',
            visible: true,
            width: 120,
          },
          // 开票人
          {
            field: 'billMakerName',
            title: 'billList.column.collectBillMakerName',
            visible: true,
            width: 120,
          },
          // 开票日期
          {
            field: 'billMakeDate',
            title: 'billList.column.collectBillMakeDate',
            visible: true,
            width: 120,
            sortable: true,
          },
          // 开票银行
          {
            field: 'billMakeBankName',
            title: 'billList.column.collectBillMakeBankName',
            visible: true,
            width: 120,
          },
          // 收票人
          {
            field: 'billTakerName',
            title: 'billList.column.collectBillTakerName',
            visible: true,
            width: 120,
          },
          // 收票日期
          {
            field: 'billTakeDate',
            title: 'billList.column.billTakeDate',
            visible: true,
            width: 120,
            sortable: true,
          },
          // 收票银行
          {
            field: 'billTakeBankName',
            title: 'billList.column.collectBillTakeBankName',
            visible: true,
            width: 120,
          },
          // 是否质押
          {
            field: 'isPledge',
            title: 'billList.column.isPledge',
            visible: true,
            width: 120,
            dictType: 'yes-no',
          },
          // 录入人
          {
            field: 'billRecorderName',
            title: 'billList.column.billRecorderName',
            visible: true,
            width: 120,
          },
          // 录入日期
          {
            field: 'billRecordDate',
            title: 'billList.column.billRecordDate',
            visible: true,
            width: 120,
            sortable: true,
          },
          /*
          // 大小票
          { field: "billSize", title: 'billDetail.baseForm.billSize', visible: true, width: 120, dictType: "billSize" },
          // 贴现日期
          { field: "fundBillDiscount.discountDate", title: 'billList.column.discountDate', visible: true, width: 120 },
          // 贴现息
          { field: "fundBillDiscount.discountCharge", title: 'billList.column.discountCharge', visible: true, width: 120 },
          // 贴现所得金额
          { field: "fundBillDiscount.discountIncomeAmount", title: 'billList.column.discountIncomeAmount', visible: true, width: 120 },
          // 贴现票据账面价值
          { field: "fundBillDiscount.billBookValue", title: 'billList.column.billBookValue', visible: true, width: 120 },
          // 背书日期
          { field: "fundBillEndorse.endorseDate", title: 'billList.column.endorseDate', visible: true, width: 120 },
          // 背书部门
          { field: "fundBillEndorse.endorseDepartmentName", title: 'billList.column.endorseDepartmentNo', visible: true, width: 120 },
          // 托收日期
          { field: "fundBillCollection.collectionDate", title: 'billList.column.collectionDate', visible: true, width: 120 },
          // 质押日期
          { field: "fundBillPledgeList[0].pledgeDate", title: 'billList.column.pledgeDate', visible: true, width: 120 },
          // 客户
          { field: "customerName", title: 'billList.column.customerName', visible: true, width: 180},
          // 入账状态
          { field: "accountingStatus", title: '入账状态', visible: true, width: 120, dictType: "post_status" },
          // 凭证号
          { field: "voucherNo", title: '凭证号', visible: true, width: 120, },
          */
        ],
        companyList: [],
        departmentList: [],
        pledgeList: [
          { value: '0', label: this.$t('billList.status.no') },
          { value: '1', label: this.$t('billList.status.yes') },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门 收票部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      //切换公司
      companyChange(val) {
        this.query.billTakeDepartmentNo = this.query.endorseDepartmentNo = null;
        this.getDepartment(val.val);
      },
      //行项目样式
      rowStyle({ row }) {
        let newDate = new Date();
        let expiringDate = new Date(row.expiringDate);
        let date = (expiringDate - newDate) / 1000 / 60 / 60 / 24;
        if (date <= 1 && date >= 0) {
          return {
            backgroundColor: 'rgb(254, 135, 131)',
          };
        }
        if (row.fundBillDiscount?.preDiscountCharge) {
          if (!row.fundBillDiscount?.discountCharge) {
            let discountDate = new Date(row.fundBillDiscount.discountDate);
            let tempDate = new Date(discountDate.getFullYear(), discountDate.getMonth() + 1, 0);
            if (newDate > tempDate) {
              return {
                backgroundColor: 'rgb(255,227,190)',
              };
            }
          }
        }
      },
      // 获取列表数据
      async getData() {
        this.load = true;
        const params = this.setSearchParams();
        let res = await this.$axios.post(API.QUERY_FUNDBILL_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageSize, pageNum };
        params.customerNoList = params.customerNoList
          ? params.customerNoList.map((item) => item.partnerCode)
          : [];
        if (XEUtils.isArray(params.customerNoList) && params.customerNoList[0])
          params.customerNoStr = params.customerNoList.join(',');
        if (XEUtils.isArray(params.billRecorderNo) && params.billRecorderNo[0]) {
          params.billRecorderNo = params.billRecorderNo[0].id;
        }
        if (XEUtils.isArray(params.billTakerName) && params.billTakerName[0]) {
          params.billTakerName = params.billTakerName[0].personName;
        }
        delete params.customerNoList;
        return params;
      },
      arrivalChange(val) {
        let item = val.val;
        if (item && item.length > 0) {
          this.query.arrivalBranchName = item[0].branchName;
          this.query.arrivalBranchCode = item[0].branchCode;
          this.query.arrivalBankAccount = item[0].bankAccountNum;
        } else {
          this.query.arrivalBranchName =
            this.query.arrivalBranchCode =
            this.query.arrivalBankAccount =
              null;
        }
      },
      // 排序
      sortChangeEvent({ property, order }) {
        this.query.searchOrderItems = [
          { column: property.replace(/([A-Z])/g, '_$1').toLowerCase(), asc: order == 'asc' },
        ];
        this.getData();
      },
      // 按钮
      chooseClick(type) {
        this.multipleSelection = this.$refs.siruiTable.getCheckboxRecords();

        if (type == 'add' || type == 'edit') {
          if (type == 'edit' && this.multipleSelection.length != 1) {
            return this.tips('onlyOneSelectData', 'error');
          }
          this.toPath(
            type == 'add' ? 'Add' : 'Edit',
            type == 'add' ? {} : { id: this.multipleSelection[0].id }
          );
        } else if (type == 'copy') {
          this.handleCopy();
        } else if (type === 'del' || type === 'cancel') {
          this.handleDel(type);
        } else if (type == 'import') {
          this.handleImport();
        } else if (type == 'export') {
          if (this.tableData.length === 0) {
            return this.tips('noExport', 'error');
          }
          this.handleExport();
        } else if (type === 'generateCredentials') {
          this.batchGenarateVoucher(
            'AE_AR_BILL',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_VOUCHER_YS,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSignSyncVoucher') {
          this.batchSyncVoucher(
            API.BATCH_SIGN_VOUCHER_YS,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
      },
      // 列表双击
      dblclickEvent(value) {
        this.toPath('Details', { id: value.row.id });
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true, '101');
      },
      // 复制
      handleCopy() {
        if (this.multipleSelection.length != 1) {
          return this.tips('onlyOneSelectData', 'error');
        }
        this.toPath('Add', { copyId: this.multipleSelection[0].id });
      },
      // 导出
      handleExport() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = 'billType=1&';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${this.baseUrl}${API.EXPORT_FUNDBILL}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = this.setSearchParams();
          params = XEUtils.serialize(params);
          window.location.href = `${this.baseUrl}${API.EXPORT_FUNDBILL}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 删除/撤销弹框
      handleDel(type) {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let apiName = type == 'del' ? 'DEL_FUNDBILL' : 'CANCEL_FUNDBILL';
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (type == 'del' && i.billStatus == '01') {
            canDelitems.push(i);
          }
          if (type == 'cancel') {
            // 这边要等财务凭证做完
            canDelitems.push(i);
          }
        });
        if (canDelitems.length == 0) {
          return this.tips(type == 'del' ? 'noCanDelSelectData' : 'noCanCancelSelectData', 'error');
        }
        let items = canDelitems.map((i) => i.id);
        let message = '';
        if (canDelitems.length !== this.multipleSelection.length) {
          message =
            type == 'del'
              ? this.$t('billList.message.hasCannotDelTip')
              : this.$t('billList.message.hasCannotCancelTip');
        }
        this.$confirmAction(
          type == 'del' ? this.$t('confirm.delete') : this.$t('billList.message.cancel'),
          message
        )
          .then(() => {
            this.del(items, apiName);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids, apiName) {
        this.$axios.post(API[apiName], ids).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`billList.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(type, query) {
        let path = {
          path: `/capital/collectBill${type}`,
          name: `collectBill${type}`,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
